import React, { FC } from 'react';

import { INavItem } from 'src/prize/types/shoppe';

import Link from '../../../../atoms/Link';
import Menu from './molecules/Menu';

import styles from './index.module.sass';

interface LinksProps {
  header?: INavItem;
}

const Links: FC<LinksProps> = ({ header }) =>
  header?.children.length > 0 ? (
    <ul className={styles.links}>
      {header.children.map(( link ) => (
        <li className={styles.item} key={`${link.id}${link.title}`}>
          {link.children.length > 0 ? (
            <Menu links={link.children}>{link.title}</Menu>
          ) : (
            <Link className={styles.link} href={link.url}>
              {link.title}
            </Link>
          )}
        </li>
      ))}
    </ul>
  ) : null;

export default Links;
